var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayCheckImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4144_17642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#E8E7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4144_17642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40H100V30H20V40ZM10 30C10 27.25 10.9792 24.8958 12.9375 22.9375C14.8958 20.9792 17.25 20 20 20H100C102.75 20 105.104 20.9792 107.062 22.9375C109.021 24.8958 110 27.25 110 30V60H20V90H40.5V100H20C17.25 100 14.8958 99.0208 12.9375 97.0625C10.9792 95.1042 10 92.75 10 90V30ZM74.75 110L53.5 88.75L60.5 81.75L74.75 95.75L103 67.5L110 74.75L74.75 110ZM20 30V90V67.5V81.625V30Z",
    fill: "#E8E7FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCheckImg);
export default __webpack_public_path__ + "static/media/pay_check_img.0cfabbeeefaef271d98fc9c43035a7de.svg";
export { ForwardRef as ReactComponent };